module.exports = __webpack_public_path__ + "img/webbing.87f07ffa.svg";